import * as React from 'react';
import * as PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import isWebView from '@medflex/utils/isWebView';
import isDesktop from '@medflex/utils/isDesktop';
import { USER_TYPES } from '@medflex/utils/constants';
import ErrorView from '@medflex/components/stories/ErrorView';
import config from '@medflex/utils/config';
import Logger from '@medflex/utils/Logger';

class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error) {
    this.setState({ hasError: true });
    Logger.error(error);
  }

  render() {
    const { hasError } = this.state;
    const { children, className, error, t, userType } = this.props;

    const appPath =
      // eslint-disable-next-line no-nested-ternary
      userType === USER_TYPES.PHYSICIAN
        ? 'arzt'
        : userType === USER_TYPES.STAFF
          ? 'mitarbeiter'
          : 'patient';

    if (!hasError && !error) return children;

    const href = `${config.BASE_URL}${config.BASE_PATH}${isWebView() || isDesktop() ? `/${appPath}` : ''}`;

    return (
      <ErrorView
        buttonLabel={t('error_page.button_label')}
        className={className || ''}
        href={href}
        text={t('error_page.text')}
        title={t('error_page.title')}
      />
    );
  }
}

ErrorPage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  error: PropTypes.shape({}),
  userType: PropTypes.oneOf([USER_TYPES.PHYSICIAN, USER_TYPES.PATIENT, USER_TYPES.STAFF]),
  t: PropTypes.func,
};

export default withTranslation()(ErrorPage);
